import { render, staticRenderFns } from "./BulkEmailForm.vue?vue&type=template&id=4836cf6e&"
import script from "./BulkEmailForm.vue?vue&type=script&lang=js&"
export * from "./BulkEmailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports